import { render, staticRenderFns } from "./lt-taskim-sections-select.vue?vue&type=template&id=3da670d5&scoped=true&"
import script from "./lt-taskim-sections-select.vue?vue&type=script&lang=js&"
export * from "./lt-taskim-sections-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da670d5",
  null
  
)

export default component.exports